import { createTheme } from '@mui/material/styles';

// Carries over the original web_interface taste: Material dark palette with the
// purple/teal accent pair, Roboto + Noto Sans JP.
const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#bb86fc' },
    secondary: { main: '#03dac6' },
    background: { default: '#121212', paper: '#1e1e1e' },
  },
  typography: {
    fontFamily: "'Roboto', 'Noto Sans JP', sans-serif",
  },
  shape: { borderRadius: 8 },
});

export default theme;
